var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.model
    ? _c("app-select-source-card", {
        attrs: { "browse-id": _vm.browseId },
        on: {
          source: function ($event) {
            return _vm.dataSourceSelected($event)
          },
          cancel: function ($event) {
            return _vm.close()
          },
          settings: function ($event) {
            _vm.settings = $event
          },
        },
      })
    : _c(
        "w-card",
        { staticClass: "card", attrs: { "max-width": "1200" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-create-report")))]),
          _c(
            "w-scroll-view",
            { staticClass: "content", attrs: { tag: "w-card-content" } },
            [
              _c("app-create-form", {
                attrs: { model: _vm.model, "browse-id": _vm.browseId },
                on: {
                  source: function ($event) {
                    return _vm.dataSourceSelected($event)
                  },
                  saved: function ($event) {
                    return _vm.onSaved()
                  },
                  loaded: function ($event) {
                    return _vm.onLoaded()
                  },
                },
                model: {
                  value: _vm.settings,
                  callback: function ($$v) {
                    _vm.settings = $$v
                  },
                  expression: "settings",
                },
              }),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.missingExcelModuleModal,
                callback: function ($$v) {
                  _vm.missingExcelModuleModal = $$v
                },
                expression: "missingExcelModuleModal",
              },
            },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.error")))]),
                  _c(
                    "w-card-content",
                    [
                      _c("app-missing-module", {
                        attrs: { "module-id": _vm.excelModule },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.missingExcelModuleModal = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.Ok")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.close")) + " ")]
              ),
              _c("w-spacer"),
              _vm.isSupportSession
                ? _c(
                    "w-button",
                    {
                      staticClass: "mr",
                      attrs: { icon: "file-pdf" },
                      on: {
                        click: function ($event) {
                          return _vm.create("chromium-pdf")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("create-chromium-pdf")) + " ")]
                  )
                : _vm._e(),
              _c(
                "w-button",
                {
                  staticClass: "mr",
                  attrs: { icon: "file-excel" },
                  on: {
                    click: function ($event) {
                      return _vm.create("excel")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("create-excel")) + " ")]
              ),
              _c(
                "w-button",
                {
                  attrs: { icon: "file-pdf" },
                  on: {
                    click: function ($event) {
                      return _vm.create("pdf")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("create-pdf")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }